import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { PageHeader, FooterLegalStrip } from '@mapbox/page-shell-components';
import { prefixBasePath } from '../util/prefix-base-path';
import { loadUserMenu } from '../util/load-user-menu';

class PageShell extends React.PureComponent {
  static defaultProps = {
    darkHeaderText: true,
    renderBuffer: true,
    includeLinks: true
  };

  renderBuffer() {
    if (!this.props.renderBuffer) return null;

    return <div className="bg-white shell-header-buffer" />;
  }

  componentDidMount() {
    loadUserMenu();
  }

  componentDidUpdate() {
    loadUserMenu();
  }

  headerItemsClickHandler(path) {
    return e => {
      e.preventDefault();
      this.props.history.push(path);
    };
  }

  render() {
    const headerItems = [];

    const body = (
      <div
        className="bg-white flex-parent flex-parent--column"
        style={{ minHeight: '100vh' }}
      >
        <div className="flex-child flex-child--no-shrink shell-wrapper">
          <div className="my12 mt24-mm mb18-mm">
            <PageHeader
              siteName="Atlas"
              items={headerItems}
              siteUri={prefixBasePath('/')}
              onSiteNameClick={this.headerItemsClickHandler('/')}
            />
          </div>
          <div className="border-b border--gray-light limiter" />
          {this.renderBuffer()}
        </div>
        <main className="flex-child flex-child--grow pt36 pb60">
          <div className="limiter">{this.props.children}</div>
        </main>
        <div className="flex-child flex-child--no-shrink shell-wrapper">
          <div className="limiter pb24">
            <FooterLegalStrip />
          </div>
        </div>
      </div>
    );
    return <div>{body}</div>;
  }
}

PageShell.propTypes = {
  darkHeaderText: PropTypes.bool,
  renderBuffer: PropTypes.bool,
  includeLinks: PropTypes.bool
};

export default withRouter(PageShell);
